import '@components/module-components/POSMap/pos-map.scss'
import {VerifiedLabelMarkupProps} from '@components/module-components/POSMap/types'
import {ENV} from '@environments/environment'
import {E_ProcessClaimedStatus} from '@src/types'
import React from 'react'
import {useSelector} from 'react-redux'

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY, URL_WEBAPP} = ENV

const FibretraceLabelMarkup: React.FC<VerifiedLabelMarkupProps> = ({className = '', poz, style = {}}) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any
  // console.log(poz)
  // <span className={"text-green fw-600 mb-1"}
  // className={"text-green text-nowrap fw-600 mt-1 mb-1"}

  return poz?.claimed_status !== E_ProcessClaimedStatus.VERIFIED ? null : (
    <span className={'ml-1 color-242424 text-nowrap ' + className} style={style}>
      {poz.fibretrace_id_label}
    </span>
  )
}

export default FibretraceLabelMarkup
